/**
 * In the /scripts/singletons/DomManager file, when using the setComponents
 * method, all components placed in export default are looped and initialized
 * automatically.
 */
import Button from "@/scripts/components/Button";
import Flyout from "@/scripts/components/Flyout";
import Github from "@/scripts/components/Github";
import Hamburger from "@/scripts/components/Hamburger";
import Header from "@/scripts/components/Header";

/**
 * If you want to pass separate parameters or want to initialize a component
 * manually, you have to:
 * - Export it by itself =>
 *   export { default as Button } from "@/scripts/components/Button";
 * - Import it in the main.js file =>
 *   import { Button } from "@/scripts/components";
 * - Use the DomManager to register it:
 *   DomManager.registerComponent(".js-button", Button);
 */
// export { default as Button } from "@/scripts/components/Button";

export default {
	Button,
	Flyout,
	Github,
	Hamburger,
	Header,
};
